/**
 * Helpers for the uniform admin-form validation UX. Error maps are
 * `field -> message`; an empty-string message means "cleared, no error"
 * (forms clear a field's error by setting it to '' rather than deleting the
 * key), so callers must treat blanks as no-error.
 */

/** True when the map has at least one non-empty error message. */
export function hasErrors(errors: Record<string, string>): boolean {
  return Object.values(errors).some((message) => Boolean(message))
}

/**
 * The lowest tab index among fields that currently have an error - i.e. the
 * earliest tab the user should be sent to on a failed submit. Returns `null`
 * when there are no mapped errors.
 */
export function firstErrorTab(
  errors: Record<string, string>,
  fieldToTab: Record<string, number>,
): number | null {
  let min: number | null = null
  for (const [field, message] of Object.entries(errors)) {
    if (!message) continue
    const tab = fieldToTab[field]
    if (tab === undefined) continue
    if (min === null || tab < min) min = tab
  }
  return min
}
